<template>
    <template v-if="props.isLoading">
        <Spinner></Spinner>
    </template>
    <template v-else>
        <div class="table_wrap">
            <table class="areaGrid">
                <thead>
                    <tr>
                        <th v-for="(col, idx) in columns" :key="idx" :class="[col.class]">
                            <template v-if="col.key === 'checkbox'">
                                <div class="checkbox_wrap">
                                    <label for="allCheckbox">
                                        <input
                                            type="checkbox"
                                            id="allCheckbox"
                                            @change="selectAll"
                                            :checked="list.length === list.filter((r:any) => r.checked).length"
                                        />
                                        <em></em>
                                    </label>
                                </div>
                            </template>
                            <template v-else>{{ col.label }}</template>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="list.length > 0">
                        <tr v-for="(row, idx) in list" :key="idx">
                            <td
                                v-for="(col, colIdx) in columns"
                                :key="colIdx"
                                v-html="fnRender(row, col, idx)"
                                v-on:click="col.clickable === true ? onRowClick(row, col) : ''"
                                :class="[col.clickable === true ? 'areaClick' : '', col.class]"
                                :style="{ cursor: col.clickable ? 'pointer' : '', textDecoration: col.clickable ? 'underline' : '' }"
                            ></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td :colspan="columns.length" class="text-center">데이터가 없습니다.</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <ul class="areaPaing" v-if="props.currentPage && props.cntPage && props.list.length > 0">
                <li class="first_page page" @click="currentPage > 1 ? fnPaging(1) : ''"></li>
                <li class="prev_page page" @click="currentPage > 1 ? fnPaging(visiblePages[0] - 1) : ''"></li>

                <li v-for="index in visiblePages" :key="index" @click="fnPaging(index)" :class="[index === currentPage ? 'active' : '']">
                    {{ index }}
                </li>
                <li class="next_page page" @click="currentPage < paging ? fnPaging(visiblePages[visiblePages.length - 1] + 1) : ''"></li>
                <li class="last_page page" @click="fnPaging(paging)"></li>
            </ul>
        </div>
    </template>
</template>

<script lang="ts" config>
    import { reactive, computed, CommonUtils, watch, Spinner } from "@/BaseComponent";
    export default {
        props: {
            list: {
                type: Array<any>,
                default: [],
            },
            columns: {
                type: Array<any>,
                default: [],
            },
            currentPage: {
                type: Number,
                default: 0,
            },
            totalLength: {
                type: Number,
                default: 0,
            },
            perPage: {
                type: Number,
                default: 0,
            },
            cntPage: {
                type: Number,
                default: 0,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        emits: ["onPaging", "onRowClick", "fnGoPage", "allClick"],
        components: { Spinner },

        setup(props: any, emits: any) {
            const state = reactive({
                list: [] as any,
                columns: {} as any,
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 0 as number,
                allClick: false as boolean,
            });
            const paging = computed(() => {
                return Math.ceil(props.totalLength / props.perPage);
            });

            const visiblePages = computed(() => {
                const pages = [];

                const start = Math.floor((props.currentPage - 1) / props.cntPage) * props.cntPage + 1;
                const end = start + 5 - 1 < paging.value ? start + 5 - 1 : paging.value;

                for (let i = start; i <= end; i++) {
                    pages.push(i);
                }

                return pages;
            });

            const fnPaging = (index: number) => {
                if (index < 1) {
                    emits.emit("onPaging", 1);
                } else if (index >= paging.value) {
                    emits.emit("onPaging", paging.value);
                } else {
                    emits.emit("onPaging", index);
                }
            };

            const onRowClick = (row: any, col: any) => {
                emits.emit("onRowClick", row, col);
            };
            const fnRender = (row: any, col: any, idx: any) => {
                if (col.render) {
                    return col.render(row);
                } else if (col.key.indexOf(".") > -1) {
                    const arr = col.key.split(".");
                    return arr.reduce((acc: any, key: any) => acc?.[key], row);
                } else if (col.key) {
                    return row[col.key];
                } else {
                    return CommonUtils.numberFormat(props.totalLength - (props.currentPage - 1) * props.perPage - idx);
                }
            };

            const selectAll = () => {
                state.allClick = !state.allClick;
                emits.emit("allClick", state.allClick);
            };

            watch(
                () => props.list,
                () => {
                    const lastPage = visiblePages.value[visiblePages.value.length - 1];
                    if (!(props.list.length > 0) && props.currentPage > lastPage) {
                        emits.emit("onPaging", lastPage);
                    }
                },
            );

            return { props, state, paging, visiblePages, fnPaging, onRowClick, fnRender, selectAll };
        },
    };
</script>
<style scoped>
    .areaPaing {
        display: flex;
        justify-content: center;
        gap: 6px;
        margin-top: 20px;
    }

    .areaPaing li {
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
        font-weight: 200;
    }

    .areaPaing li.page {
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        filter: invert(58%) sepia(52%) saturate(651%) hue-rotate(155deg) brightness(89%) contrast(89%);
    }

    .areaPaing li.first_page {
        background-image: url("../assets/db_arrow.png");
        transform: rotate(180deg);
        background-position: 50% 38%;
    }

    .areaPaing li.prev_page {
        background-image: url("../assets/arrow.png");
        transform: rotate(180deg);
        background-position: 50% 38%;
    }

    .areaPaing li.next_page {
        background-image: url("../assets/arrow.png");
    }

    .areaPaing li.last_page {
        background-image: url("../assets/db_arrow.png");
    }

    .areaPaing li.active {
        font-weight: 700;
        border-radius: 50px;
        color: var(--blue_color);
    }
</style>
